import React from "react";
import toriGate from "../assets/img/tori-gate.png";
import {X} from "react-feather"

export default function Modal({ showModal, setShowModal, highScore }) {
  ////console.log(highScore);
  return (
    <>
      {showModal ? (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center max-w-md mx-auto my-6 overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div
              className="relative flex flex-col w-full rounded-lg shadow-lg outline-none focus:outline-none"
              style={{
                background: `linear-gradient(
                    rgba(0, 0, 0, 0.3), 
                    rgba(0, 0, 0, 0.3)
                  ), url(${toriGate}) no-repeat center/cover`,
              }}
            >
              <div className="flex items-start justify-between p-5 rounded-t">
                <h3 className="text-xl font-semibold">High Scores</h3>
                <X className="cursor-pointer" onClick={() => setShowModal(false)} />
              </div>
              <div className="relative flex-auto px-6 pb-6 text-center">
                {Object.keys(highScore).map((key) => {
                  return (
                    <div className="mb-4" key={key}>
                      <h1>{key}</h1>
                      <p className="font-mono text-5xl">{highScore[key]}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div
            className="fixed inset-0 z-40 bg-black opacity-70"
            onClick={() => setShowModal(false)}
          />
        </>
      ) : null}
    </>
  );
}
